export default __webpack_public_path__ + "static/side-nav-dont-1-97a5b9cb4305ff060712a696e74af2b13ad11ad3dadbe08800c0309df3b516fa.png";